import { api } from "../client";

export interface AdminUser {
  id: string;
  email: string;
  display_name: string;
  is_admin: boolean;
  is_disabled: boolean;
  created_at: number;
}

export interface CreateUserInput {
  email: string;
  display_name: string;
  /** Omit to have the hub generate one and return it once. */
  password?: string;
  is_admin?: boolean;
}

export interface CreateUserResult {
  user: AdminUser;
  /** Present only when the hub generated the password. Show once, then drop. */
  generated_password: string | null;
}

export const usersApi = {
  list: () => api<{ users: AdminUser[] }>("/v1/admin/users"),
  create: (input: CreateUserInput) =>
    api<CreateUserResult>("/v1/admin/users", { method: "POST", body: input }),
  patch: (
    id: string,
    input: { display_name?: string; is_admin?: boolean; password?: string },
  ) => api<{ ok: true }>(`/v1/admin/users/${id}`, { method: "PATCH", body: input }),
  disable: (id: string) =>
    api<{ ok: true }>(`/v1/admin/users/${id}/disable`, { method: "POST" }),
  enable: (id: string, password?: string) =>
    api<{ ok: true; generated_password: string | null }>(
      `/v1/admin/users/${id}/enable`,
      { method: "POST", body: password ? { password } : {} },
    ),
};
